const DISPLAY_TYPES={
	"RADIO": 1,
	"CHECKBOX": 2,
	"SELECT": 3,
	"TEXT": 4,
	"TEXTAREA": 5
}

export { DISPLAY_TYPES }